import { render, staticRenderFns } from "./InputPage.vue?vue&type=template&id=37b02a6c&scoped=true"
import script from "./InputPage.vue?vue&type=script&lang=js"
export * from "./InputPage.vue?vue&type=script&lang=js"
import style0 from "./InputPage.vue?vue&type=style&index=0&id=37b02a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b02a6c",
  null
  
)

export default component.exports